export const LOCALE_NAMESPACE = "usage-stats";

export const zh = {
	"oauth.opencodeGo.protocol": "请求协议",
	"oauth.opencodeGo.protocolHint":
		"此协议作用于 Go 服务的全部模型。请按模型官方协议选择；切换前需在 DSH 模型设置中移除使用其他协议的模型。",
	"capabilities.accountRequired": "连接该服务的账户后，这些能力才能实际使用。",
	"gateway.go.title": "外部工具使用 OpenCode Go",
	"gateway.go.hint":
		"客户端需使用下面的完整模型名和对应协议（coding-opencode-go/<model-id>；过渡期仍接受 opencode-go/<model-id>），每段对话发送稳定的 x-opencode-session 请求头。现有本地密钥只用于客户端认证；上游密钥从所选凭据来源读取。",
	"gateway.go.migration": "检测到旧的全局转发模式。请先检查客户端调整预览，再应用模型路由。本地密钥保持不变。",
	"gateway.go.empty": "尚未选择 Go 路由。请先在“账户与模型”连接 Go，再在此查看已配置模型。",
	"gateway.go.edit": "查看 Go 路由预览",
	"gateway.go.apply": "应用此路由",
	"gateway.go.disable": "移除 Go 路由",
	"gateway.go.cancel": "关闭预览",
	"gateway.go.credential": "上游凭据来源",
	"oauth.usageProviderScope": "供应商用量快照，尚未关联到具体登录账户。",
	"settings.accountsTitle": "账户与模型",
	"settings.accountsIntro": "连接服务、管理账户授权并选择展示的模型。",
	"settings.costBasis": "Token 费用为按定价估算的用量成本；订阅支出单独管理，不代表供应商实际账单。",
	"settings.tab.overview": "概览",
	"settings.unsavedConfirm": "当前修改尚未保存，确定离开并放弃这些修改吗？",
	"oauth.opencodeGo.status.conflict": "会话头配置冲突，请修改连接并移除静态会话头。",
	"oauth.opencodeGo.status.cancelled": "最近一次 Go 调用已取消。",
	"oauth.opencodeGo.status.pending": "Go 调用正在进行，等待完整结果。",
	"oauth.opencodeGo.configurationChanged": "其他页面已修改配置。读取最新配置并核对后，再应用当前输入。",
	"oauth.opencodeGo.readOnly": "此凭据来源或模型设置为只读。可复用已有授权；写入操作暂不可用。",
	"oauth.opencodeGo.applied": "模型配置已应用，请在 DSH 中选择模型开始对话。",
	"oauth.opencodeGo.credentialSaved": "凭据已保存或确认复用，尚未验证对话。",
	"oauth.opencodeGo.reload": "读取最新配置并保留输入",
	"oauth.opencodeGo.cancel": "取消修改",
	"oauth.opencodeGo.edit": "修改连接",
	"sidebar.label": "用量中心",
	"sidebar.open": "打开用量速览",
	"peek.title": "用量速览",
	"peek.dashboard": "打开完整仪表盘",
	"peek.quotaStrip": "最紧张配额",
	"dashboard.title": "用量与配额",
	"dashboard.subtitle": "仅存储本地统计 · 成本均为估算",
	"dashboard.loading": "正在加载本地统计…",
	"dashboard.error": "暂时无法读取统计：{message}",
	"error.browserContext":
		"DSH Web 请求来源校验未通过。请刷新当前页面；若通过反向代理访问，仅转发 X-Forwarded-Host/X-Forwarded-Proto 不足，还需配置受信任 peer、精确 HTTPS Origin/Host、owner proof，并通过 Fetch Metadata；变更请求还需 CSRF。",
	"dashboard.empty": "尚无可展示的数据",
	"dashboard.noData": "尚未采集到用量。先连接订阅或配置供应商；成功同步后，这里会区分真实零用量与未采集状态。",
	"dashboard.updated": "更新于 {time} 前",
	"dashboard.stale": "上次成功更新于 {time} 前 · 数据已过期",
	"dashboard.staleData": "当前展示的是最后一次成功数据，数据源已标记为过期。",
	"dashboard.retainedAfterError": "刷新失败，已保留最后一次成功数据：{message}",
	"dashboard.coverage": "{value}% 已定价",
	"dashboard.tab.overview": "概览",
	"dashboard.tab.activity": "趋势",
	"dashboard.tab.accounts": "账户",
	"dashboard.tab.breakdown": "明细",
	"dashboard.tab.local": "本机",
	"metric.tokens": "Token",
	"metric.cost": "估算成本",
	"metric.requests": "请求",
	"metric.cacheHit": "缓存命中率",
	"metric.providers": "活跃供应商",
	"metric.alerts": "提醒",
	"range.today": "今天",
	"range.7d": "7 天",
	"range.30d": "30 天",
	"range.month": "本月",
	"group.provider": "按供应商",
	"group.model": "按模型",
	"group.none": "总量",
	"toolbar.compare": "对比上一周期",
	"toolbar.refresh": "刷新",
	"toolbar.refreshing": "刷新中…",
	"toolbar.export": "导出",
	"toolbar.exportCsv": "导出 CSV",
	"toolbar.exportJson": "导出 JSON",
	"toolbar.exportDaily": "日序列 CSV",
	"toolbar.exportBundle": "打包 JSON",
	"toolbar.clearFilter": "清除筛选",
	"toolbar.range": "时间范围",
	"toolbar.metric": "指标",
	"toolbar.group": "分组",
	"alert.level.info": "信息",
	"alert.level.warning": "警告",
	"alert.level.critical": "严重",
	"alert.dailyCost": "今日估算成本（{currency}）",
	"accounts.emptyGuide": "尚未发现可监控账户。可在设置 → 订阅账号中登录或添加凭据。",
	"accounts.configure": "前往配置账户",
	"accounts.manage": "管理订阅账号",
	"accounts.roiBadge": "订阅 {monthly} · 本月用量 {usage} · 回本 ×{payback}",
	"breakdown.priced": "{value}% 已定价",
	"pricing.providerPattern": "供应商模式",
	"pricing.modelPattern": "模型模式",
	"pricing.inputPerMillion": "输入 / 百万",
	"pricing.outputPerMillion": "输出 / 百万",
	"pricing.cacheReadPerMillion": "缓存读 / 百万",
	"pricing.cacheWritePerMillion": "缓存写 / 百万",
	"pricing.add": "添加价格规则",
	"pricing.remove": "删除",
	"pricing.presetsHint": "一键加载常见供应商估算单价（可再编辑后保存）：",
	"pricing.preset.openai": "OpenAI 模板",
	"pricing.preset.anthropic": "Anthropic 模板",
	"pricing.preset.deepseek": "DeepSeek 模板",
	"fees.datePlaceholder": "YYYY-MM-DD",
	"activity.title": "活动热力图",
	"activity.streak": "连续 {current} 天 · 最长 {longest} 天",
	"activity.metricTokens": "按 Token 着色（滚动 370 天）",
	"activity.metricCost": "按估算成本着色（滚动 370 天）",
	"activity.metricRequests": "按请求数着色（滚动 370 天）",
	"activity.less": "少",
	"activity.more": "多",
	"activity.weekday.sun": "日",
	"activity.weekday.mon": "一",
	"activity.weekday.tue": "二",
	"activity.weekday.wed": "三",
	"activity.weekday.thu": "四",
	"activity.weekday.fri": "五",
	"activity.weekday.sat": "六",
	"activity.dayDetail": "单日详情",
	"activity.dayRequests": "请求 {value}",
	"activity.clearDay": "清除选择",
	"module.kpi": "概览指标",
	"module.heatmap": "活动热力图",
	"module.trend": "趋势",
	"module.accounts": "账户与配额",
	"module.alerts": "提醒",
	"module.breakdown": "维度明细",
	"module.local": "本机认证与用量",
	"local.auth.title": "本机认证状态",
	"local.auth.hint": "只读探测白名单内的官方 CLI 凭据与本插件的 OAuth 会话；不会读取或显示任何令牌内容。",
	"local.auth.disabled": "本机认证监控已关闭。在插件配置中设置 localMonitor.enabled: true 后重启即可开启。",
	"local.auth.signedIn": "已登录",
	"local.auth.signedOut": "未登录",
	"local.auth.expired": "已过期",
	"local.auth.noExpiry": "无过期时间",
	"local.auth.expiresAt": "约 {time} 后到期",
	"local.auth.hasRefresh": "含刷新令牌",
	"local.auth.pluginSession": "DSH 会话 · {route}",
	"local.auth.pluginSessionHint": "本插件保存的 OAuth 登录",
	"local.usage.title": "跨工具本机用量",
	"local.usage.hint": "解析本机其他 CLI 的会话日志，仅提取时间、模型与 Token 计数；不读取任何对话内容。",
	"local.usage.disabled": "跨工具用量扫描已关闭（默认）。在插件配置中设置 localUsage.enabled: true 后重启即可开启。",
	"local.usage.empty": "尚未扫描到本机用量数据",
	"local.usage.scan": "立即扫描",
	"local.usage.scanning": "扫描中…",
	"local.usage.neverScanned": "尚未扫描",
	"local.openCapabilities": "打开能力设置",
	"local.usage.tool": "工具",
	"local.usage.models": "模型数",
	"statusProbes.title": "供应商状态页",
	"statusProbes.hint":
		"只读探测白名单内的公开 Statuspage（无凭据、遵守出站/SSRF 策略）。默认关闭；失败不影响用量主路径。",
	"statusProbes.disabled":
		"供应商状态页探测已关闭（默认）。在插件配置中设置 statusProbes.enabled: true 后重启即可开启。",
	"statusProbes.empty": "暂无探测结果",
	"statusProbes.indicator.none": "正常",
	"statusProbes.indicator.minor": "轻微",
	"statusProbes.indicator.major": "重大",
	"statusProbes.indicator.critical": "严重",
	"statusProbes.indicator.unknown": "未知",
	"statusProbes.failed": "探测失败（{code}）",
	"trend.title": "趋势",
	"breakdown.title": "维度明细",
	"breakdown.dimension": "维度",
	"breakdown.tokens": "Token",
	"breakdown.share": "占比",
	"breakdown.requests": "请求",
	"breakdown.cache": "缓存",
	"breakdown.cost": "成本",
	"comparison.none": "暂无对比基线",
	"comparison.change": "较上一周期 {value}",
	"accounts.title": "账户与配额",
	"accounts.empty": "尚未发现可监控账户",
	"accounts.remaining": "剩余",
	"accounts.reset": "{time} 后重置",
	"accounts.lastGood": "上次成功 {time}",
	"status.stale": "数据已过期",
	"status.updated": "刚刚更新",
	"status.ok": "正常",
	"status.pending": "等待中",
	"status.not-configured": "未配置",
	"status.unsupported": "暂无配额查询",
	"status.auth-error": "认证失败",
	"status.rate-limited": "限流",
	"status.unavailable": "不可用",
	"status.error": "错误",
	"breakdown.cacheRead": "缓存读",
	"breakdown.cacheWrite": "缓存写",
	"breakdown.input": "输入",
	"breakdown.output": "输出",
	"settings.autoExport": "自动导出目录",
	"settings.autoExportHint": "仅写入本机绝对路径；永不写入凭据或 session。留空禁用。",
	"settings.autoExportEnabled": "启用定时导出到本机目录",
	"settings.autoExportPath": "导出目录（绝对路径）",
	"settings.autoExportLayout": "导出布局",
	"settings.nav": "用量",
	"settings.title": "用量",
	"settings.patchFailed": "设置未保存；当前更改仍保留。请重新读取最新设置后决定如何处理。",
	"settings.reload": "重新读取最新设置",
	"settings.conflictNoOverlap": "设置已在其他位置更新。你的修改没有覆盖同一组字段，可以基于最新设置重新应用。",
	"settings.conflictFields": "以下设置同时被修改：{fields}。请选择保留自己的修改，或采用最新设置。",
	"settings.conflictSeparator": "、",
	"settings.keepLocal": "保留我的修改并重新应用",
	"settings.useLatest": "采用最新设置",
	"settings.section.display": "显示",
	"settings.section.providers": "供应商显示",
	"settings.section.privacy": "隐私",
	"settings.section.alerts": "提醒",
	"settings.intro": "查看用量、配额与数据更新时间，按需调整显示和费用估算。",
	"onboarding.title": "三步完成首次设置",
	"onboarding.intro": "先连接订阅，再确认定价口径，最后按需启用本地 Gateway。每一步都可稍后调整。",
	"onboarding.progress": "已完成 {completed} / {total}",
	"onboarding.subscription.title": "连接订阅",
	"onboarding.subscription.hint": "登录至少一个 Coding OAuth 账户，并选择要展示的模型。",
	"onboarding.pricing.title": "同步或配置定价",
	"onboarding.pricing.hint": "载入价格模板或自定义规则，避免把未定价用量误认为零成本。",
	"onboarding.gateway.title": "配置 Gateway",
	"onboarding.gateway.hint": "如需本机 API 入口，再启用 loopback Gateway 并生成独立密钥。",
	"onboarding.gateway.skip": "不需要 Gateway",
	"onboarding.loading": "正在检查当前配置…",
	"onboarding.start": "开始",
	"onboarding.review": "检查",
	"settings.preview": "打开完整仪表盘",
	"settings.openPeek": "打开用量速览",
	"settings.tab.display": "显示",
	"settings.tab.accounts": "服务与账户",
	"settings.tab.gateway": "网关",
	"settings.tab.capabilities": "能力",
	"settings.tab.providers": "其他服务",
	"settings.tab.fees": "费用",
	"settings.display": "显示与默认视图",
	"settings.preset": "仪表盘预设",
	"settings.sidebarMetric": "侧栏/悬浮指标",
	"settings.entryMode": "入口形态",
	"settings.entryMode.sidebar": "侧栏按钮",
	"settings.entryMode.floating": "悬浮小窗",
	"settings.entryModeHint": "多插件挤占侧栏时可改用悬浮小窗；设置页始终可打开用量",
	"hud.more": "+{count}",
	"hud.openPeek": "打开用量速览",
	"settings.defaultRange": "默认范围",
	"settings.compare": "默认对比上一周期",
	"settings.density": "界面密度",
	"settings.motion": "动态效果",
	"preset.minimal": "精简",
	"preset.quota": "配额",
	"preset.cost": "成本",
	"preset.analyst": "分析",
	"density.compact": "紧凑",
	"density.comfortable": "舒适",
	"motion.system": "跟随系统",
	"motion.always": "始终减少",
	"motion.never": "始终启用",
	"settings.timeZone": "时区",
	"settings.baseCurrency": "基础货币",
	"settings.streakMinTokens": "连续活跃阈值（Token）",
	"settings.modules": "仪表盘模块",
	"settings.modulesHint": "勾选显示并调整顺序。自定义后切换预设不会覆盖模块布局；可重置为当前预设。",
	"settings.resetModules": "重置为当前预设",
	"settings.moveUp": "上移",
	"settings.moveDown": "下移",
	"settings.alias": "显示别名",
	"settings.color": "图表颜色",
	"settings.privacy": "隐私与导出",
	"settings.alerts": "本地软提醒",
	"settings.alertsEnabled": "启用配额、成本与账户异常提醒",
	"settings.quotaThreshold": "配额剩余阈值（%）",
	"settings.dailyCostThreshold": "每日估算成本阈值（留空禁用）",
	"settings.showSessions": "允许在明细中显示会话标识",
	"settings.redactExports": "导出时隐藏敏感标识",
	"settings.save": "保存设置",
	"settings.saving": "保存中…",
	"settings.saved": "设置已保存",
	"settings.fees": "订阅与充值费用",
	"settings.feesIntro": "本地账本，仅用于回本估算展示；不会出现在默认导出中。货币需与基础货币一致才会显示回本倍数。",
	"settings.feesSaved": "费用账本已保存",
	"settings.credentials": "供应商与凭据",
	"settings.credentialsIntro": "连接状态由本机服务端汇总。凭据值、授权码和供应商原始响应不会返回浏览器。",
	"settings.providersTitle": "供应商状态与操作",
	"settings.providersIntro":
		"查看连接状态并直接在卡片内维护认证：保存/清除 API Key、发起设备授权、按供应商刷新，或跳转「订阅账号」完成 OAuth 登录。",
	"settings.apiCredentials": "API Key 与设备授权（高级）",
	"settings.apiCredentialsIntro":
		"常规维护请直接使用上方供应商卡片；此处可按凭据引用名手动读写任意允许的凭据。凭据值不会返回浏览器。",
	"settings.accountVisibility": "账户用量展示",
	"settings.accountVisibilityHint": "开关控制 Peek 与仪表盘「账户与配额」是否展示该账户；可设置别名与图表颜色。",
	"settings.accountVisible": "在仪表盘显示 {name}",
	"settings.accountShown": "已在用量视图中展示",
	"settings.accountHidden": "已从用量视图隐藏",
	"fees.kind": "类型",
	"fees.subscription": "订阅",
	"fees.topup": "充值",
	"fees.providerId": "供应商 ID",
	"fees.planName": "套餐名称",
	"fees.amount": "金额",
	"fees.currency": "货币",
	"fees.interval": "周期",
	"fees.intervalMonth": "月",
	"fees.intervalYear": "年",
	"fees.nextRenewal": "续费日 {date}",
	"fees.nextRenewalDate": "下次续费日",
	"fees.monthlyEquivalent": "月均约 {value}",
	"fees.payback": "本月用量回本 ×{value}",
	"fees.paybackUnavailable": "回本不可用（货币不一致或本月成本未覆盖）",
	"fees.notes": "备注",
	"fees.add": "添加费用条目",
	"fees.remove": "删除",
	"fees.errorRequired": "请填写此字段",
	"fees.errorAmount": "请输入不小于零的金额",
	"fees.errorDate": "请输入有效日期（YYYY-MM-DD）",
	"fees.loading": "正在加载费用记录…",
	"fees.loadFailed": "费用记录加载失败：{message}",
	"providers.connected": "已连接",
	"providers.needsAttention": "需处理",
	"providers.unconfigured": "未配置",
	"providers.unsupported": "不支持",
	"providers.auth": "认证",
	"providers.models": "模型",
	"providers.quota": "配额",
	"providers.token": "令牌",
	"providers.empty": "还没有可管理的供应商。",
	"providers.showInDashboard": "仪表盘展示",
	"providers.showInDashboardNamed": "在仪表盘显示 {name}",
	"providers.openAccounts": "去订阅账号登录/拉取",
	"providers.credentialsTitle": "凭据维护",
	"providers.credentialOAuthManaged": "由「订阅账号」的 OAuth 登录 / 本机 CLI 拉取维护。",
	"providers.credentialReadOnly": "当前服务端凭据存储为只读，请在配置中维护该引用。",
	"providers.refreshNow": "立即刷新",
	"providers.refreshing": "刷新中…",
	"providers.deviceDone": "已授权并保存",
	"providers.group.needsAttention": "需处理",
	"providers.group.connected": "已连接",
	"providers.group.unconfigured": "未配置",
	"providers.group.unsupported": "不支持监测",
	"providers.next.unsupported": "该供应商暂不支持配额监测，可保留路由但不会出现可用额度卡。",
	"providers.next.connected": "已连接。可用上方开关控制是否在仪表盘展示。",
	"providers.next.oauth": "这是订阅/OAuth 供应商：到「订阅账号」登录，或在同一卡片内从本机 CLI 拉取凭据。",
	"providers.next.apiKey": "需要 API Key：在本卡片「凭据维护」中保存对应密钥。",
	"providers.next.refresh": "令牌即将过期或已过期：请重新登录或刷新凭据。",
	"providers.next.review": "请检查认证与配额状态，按需登录、保存 Key 或隐藏该供应商。",
	"connection.connected": "已连接",
	"connection.signing-in": "授权中",
	"connection.configured-failing": "已配置但失败",
	"connection.configured-unknown": "已配置未验证",
	"connection.unconfigured": "未配置",
	"connection.expired": "已过期",
	"connection.expiring": "即将过期",
	"connection.unavailable": "暂时不可用",
	"connection.unsupported": "不支持监测",
	"authSource.api-key": "API Key",
	"authSource.oauth": "OAuth 订阅",
	"authSource.local-cli": "本地 CLI",
	"authSource.mixed": "混合",
	"authSource.none": "无",
	"tokenLifecycle.valid": "有效",
	"tokenLifecycle.expiring": "即将过期",
	"tokenLifecycle.refresh-required": "需要刷新",
	"tokenLifecycle.unknown": "未知",
	"tokenLifecycle.none": "无令牌",
	"modelState.enabled": "已接入",
	"modelState.available-not-enabled": "有模型未启用",
	"modelState.none": "无模型",
	"modelState.unknown": "未知",
	"quotaState.available": "可读取",
	"quotaState.stale": "陈旧",
	"quotaState.disabled": "已关闭",
	"quotaState.unavailable": "不可用",
	"quotaState.not-supported": "不支持",
	"quotaState.unlinked": "未关联",
	"quotaDiag.missing-credential": "缺少配额凭据",
	"quotaDiag.missing-chatgpt-account-id": "令牌缺少 ChatGPT account id，请重新登录 Codex",
	"quotaDiag.invalid-response": "上游响应无法解析为额度窗口",
	"quotaDiag.auth-error": "凭据无效或已过期",
	"quotaDiag.unauthorized": "未授权",
	"quotaDiag.rate-limited": "上游限流",
	"quotaDiag.unavailable": "上游不可用",
	"quotaDiag.unsupported": "上游不支持该探测",
	"quotaDiag.managed-externally": "由外部插件管理",
	"quotaDiag.warning:remaining-percent": "剩余额度偏低",
	"quotaDiag.critical:remaining-percent": "剩余额度告急",
	"quotaDiag.warning:balance": "余额偏低",
	"quotaDiag.critical:balance": "余额告急",
	"quotaDiag.upstream-error": "上游探测失败",
	"credential.ref": "凭据引用",
	"credential.value": "新凭据值",
	"credential.configured": "已配置",
	"credential.missing": "未配置",
	"credential.save": "安全保存",
	"credential.remove": "移除",
	"credential.import": "导入本地 CLI 凭据",
	"credential.provider": "本地 CLI",
	"credential.oauth": "设备授权",
	"credential.oauthHint": "需要在运行时配置你信任的 GitHub 公共 OAuth 客户端 ID。",
	"credential.error": "凭据操作失败",
	"credential.start": "开始授权",
	"credential.poll": "我已完成授权",
	"credential.open": "打开授权页面",
	"credential.code": "输入代码 {code}",
	"pricing.title": "自定义价格",
	"pricing.intro": "按供应商/模型配置每百万 Token 的估算价格。未覆盖部分不会被猜测。",
	"pricing.import": "导入 JSON",
	"pricing.invalid": "价格 JSON 格式无效",
	"pricing.previewTitle": "应用 {source} 前预览差异",
	"pricing.previewDiff": "新增 {added} 条，修改 {changed} 条，移除 {removed} 条。",
	"pricing.previewDirty": "当前有尚未保存的编辑；继续会用预览内容替换这些草稿。",
	"pricing.previewApply": "确认替换",
	"pricing.undo": "撤销上次替换",
	"oauth.accountsIntro":
		"OpenCode Go 使用 API key；订阅服务按支持方式使用 OAuth 或导入已有授权。连接后选择模型，在 DSH 中使用。",
	"oauth.status.signedOut": "未登录",
	"oauth.status.signingIn": "授权中",
	"oauth.status.signedIn": "已登录",
	"oauth.status.error": "异常",
	"oauth.recovery.reauthorize": "登录凭据已失效或授权被拒绝，请重新授权。",
	"oauth.recovery.storage": "本机登录存储无法更新，请处理存储或写入锁后重新读取。",
	"oauth.recovery.network": "无法连接本机服务或请求已超时，请重新读取状态。",
	"oauth.recovery.retry": "无法完成该操作，请重新读取状态后重试。",
	"oauth.recovery.reauthorizeAction": "重新授权",
	"oauth.recovery.manageAccount": "刷新并管理账户",
	"oauth.reauthorizeHint":
		"仅更新此账户的授权，不切换默认账户。若服务不提供账户身份，请先在授权页面确认使用的是此账户。",
	"oauth.recovery.retryAction": "重新读取状态",
	"oauth.grokNote": "SuperGrok / X Premium 订阅，走 Grok Build 通道。远程或无头环境请用设备码登录。",
	"oauth.note.codex": "ChatGPT Plus/Pro 订阅。远程或无头环境推荐设备码登录。",
	"oauth.note.kimi": "Kimi Code 订阅，仅支持设备码登录。",
	"oauth.note.claude": "Claude Pro/Max 订阅。远程浏览器可把完整 localhost 回调地址粘贴回来。",
	"oauth.note.copilot": "GitHub Copilot 订阅。需在配置中设置 oauthDevice.copilotClientId 后才会出现；使用设备码登录。",
	"oauth.loginBrowser": "浏览器授权",
	"oauth.loginDevice": "设备码登录",
	"oauth.cancelLogin": "取消授权",
	"oauth.openPage": "打开授权页面",
	"oauth.pasteCode": "粘贴授权码或完整回调地址",
	"oauth.submitCode": "提交授权码",
	"oauth.waitingDevice": "请在授权页面输入上方代码，完成后此处会自动更新。",
	"oauth.logout": "退出登录",
	"oauth.accountsListHint": "本机保存的订阅账号（不含令牌）：",
	"oauth.accountActive": "当前默认",
	"oauth.accountSetDefault": "设为默认",
	"oauth.accountDefaultHint": "设为默认只影响之后发出的请求。",
	"oauth.accountRemove": "移除",
	"oauth.accountRemoveConfirm": "确认从 DSH 本地存储移除 {account}？不会修改官方 CLI 的授权文件。",
	"oauth.accountRemoveConfirmAction": "确认移除",
	"oauth.logoutConfirmHint": "确认退出此供应商在 DSH 本地保存的登录？不会修改官方 CLI 的授权文件。",
	"oauth.logoutConfirmAction": "确认退出",
	"oauth.accountAdd": "添加账号",
	"oauth.accountsAtCap": "已达到 {max} 个账号上限，请先移除一个再添加。",
	"oauth.tokenExpired": "访问令牌已过期，将在下次请求前自动刷新",
	"oauth.tokenExpiresIn": "访问令牌约 {value} 后到期（自动刷新）",
	"oauth.modelsHint": "模型展示设置对该服务的所有账户生效。取消全选会隐藏全部模型并保留授权。",
	"oauth.modelsDefault": "使用默认模型集合",
	"oauth.modelsHideAll": "取消全选",
	"oauth.modelsHidden": "账户已连接，尚未展示模型。",
	"oauth.modelsEmpty": "目录暂无可用模型",
	"oauth.modelsSave": "保存模型选择",
	"oauth.modelsSaved": "模型选择已保存",
	"oauth.antigravity.title": "Google Antigravity",
	"oauth.antigravity.installed": "已由 dsh-agy 插件提供，账号管理请使用其 CLI。",
	"oauth.antigravity.notInstalled": "未安装。可选安装固定版本的 dsh-agy 插件后使用。",
	"oauth.importTitle": "从本机 CLI 拉取凭据",
	"oauth.importHint": "只读发现白名单内的官方 CLI OAuth 文件，预览并确认后单向拉取一份副本；官方 CLI 文件不会被修改。",
	"oauth.importInlineHint": "也可从本机官方 CLI 拉取（只读预览后确认；不修改官方 CLI 文件）。",
	"oauth.importPull": "预览并拉取",
	"oauth.importClaudeCode": "导入 Claude Code",
	"oauth.importCommit": "确认拉取",
	"oauth.usageCachedHint": "供应商汇总用量窗口（本地缓存，只读；不保证精确归属到单个账号）",
	"oauth.importCancel": "取消",
	"oauth.importConfirmOverwrite": "确认用 CLI 凭据覆盖当前已保存的登录",
	"oauth.importUnavailable.missing": "未发现",
	"oauth.importUnavailable.unsafe": "文件权限不安全",
	"oauth.importUnavailable.invalid": "内容无法识别",
	"oauth.importUnavailable.too_large": "文件过大",
	"oauth.importConflict.none": "当前未保存登录",
	"oauth.importConflict.same_credential": "与已保存登录相同",
	"oauth.importConflict.same_account": "与已保存登录属于同一账号",
	"oauth.importConflict.different_account": "与已保存登录属于不同账号",
	"oauth.importConflict.unknown_account": "无法确认是否与已保存登录属于同一账号",
	"oauth.importConflict.unreadable_destination": "已保存的登录无法解析",
	"oauth.importConflict.unsafe_destination": "已保存凭据文件权限不安全",
	"oauth.importAction.import": "将拉取为新登录",
	"oauth.importAction.reuse": "无需变更",
	"oauth.importAction.overwrite": "将覆盖已保存登录",
	"oauth.importAction.blocked": "已阻止",
	"oauth.importDone.imported": "已拉取",
	"oauth.importDone.unchanged": "无需变更",
	"oauth.importDone.overwritten": "已覆盖",
	"oauth.opencodeGo.title": "OpenCode Go",
	"oauth.opencodeGo.description":
		"在独立供应商 coding-opencode-go 下连接 OpenCode Go，再在 DSH 选择模型对话；无需开启外部网关，也不占用原生 opencode-go。",
	"oauth.opencodeGo.providerIdHint": "插件供应商 id：{providerId}（与 DSH 原生 opencode-go 隔离）",
	"oauth.opencodeGo.legacyMigration":
		"检测到旧版插件配置仍写在 {legacyId}。迁移到 {providerId} 后，对话不再与 DSH 原生供应商共用同一槽位。",
	"oauth.opencodeGo.migrate": "迁移到独立供应商",
	"oauth.opencodeGo.compatibilityNote": "以上状态仅表示请求头兼容，不代表 OAuth 登录，也不代表配额或模型调用成功。",
	"oauth.opencodeGo.credential": "凭据来源",
	"oauth.opencodeGo.configured": "已配置",
	"oauth.opencodeGo.chooseCredential": "检测到多个不同的 Go 凭据，请明确选择本次使用的账户。",
	"oauth.opencodeGo.apiKey": "API key",
	"oauth.opencodeGo.reuseHint": "留空以复用已有凭据",
	"oauth.opencodeGo.reuse": "复用此凭据",
	"oauth.opencodeGo.saveKey": "保存密钥",
	"oauth.opencodeGo.fetchModels": "获取模型",
	"oauth.opencodeGo.model": "模型",
	"oauth.opencodeGo.modelsHint":
		"先获取完整目录，再勾选与当前协议匹配的模型。目录若只返回 id，思维强度会用已知 Go 能力补齐。",
	"oauth.opencodeGo.modelsEmpty": "尚未加载模型。先获取目录，再在此勾选。",
	"oauth.opencodeGo.selectMatching": "启用当前协议全部模型",
	"oauth.opencodeGo.clearModels": "清空选择",
	"oauth.opencodeGo.directoryLoaded": "已获取完整模型目录。请勾选要启用的模型，再应用到 DSH。",
	"oauth.opencodeGo.conflictPreview": "将修正以下配置：{conflicts}。其他设置保留。",
	"oauth.opencodeGo.confirmConflict": "我已核对并同意这些配置变更",
	"oauth.opencodeGo.apply": "应用到 DSH",
	"oauth.opencodeGo.startConversation": "开始对话",
	"oauth.opencodeGo.status.no-call": "尚未发出 OpenCode Go 对话请求。",
	"oauth.opencodeGo.status.success": "最近一次 Go 调用已正常完成。",
	"oauth.opencodeGo.status.failure": "最近一次 OpenCode Go 对话请求失败；检查 DSH 模型配置后重试。",
	"oauth.opencodeGo.status.missing-session": "DSH 未提供会话标识。返回对话后重试。",
	"oauth.opencodeGo.regionOptIn": "该模型仅在中国托管，需在 OpenCode 工作区显式开启（China workspace opt-in）。",
	"gateway.intro": "可选的本机 OpenAI/Anthropic 兼容网关，复用已登录的订阅会话，仅供本机工具使用，不是公网中继。",
	"gateway.enabled": "启用本地 API 网关",
	"gateway.opencodeGoEnabled": "将聊天代理到 OpenCode Go",
	"gateway.opencodeGoHint":
		"旧全局转发模式仅保留迁移识别，已停止把本地访问密钥当作上游凭据。请先在“账户与模型”连接 Go。",
	"gateway.running": "监听中",
	"gateway.stopped": "未运行",
	"gateway.bind": "监听地址",
	"gateway.bindHint": "监听地址只能在插件配置 YAML 中修改；非回环地址必须配置密钥。",
	"gateway.port": "监听端口",
	"gateway.portApply": "应用",
	"gateway.portRandom": "随机",
	"gateway.baseUrlOpenai": "OpenAI Base URL",
	"gateway.baseUrlAnthropic": "Anthropic Base URL",
	"gateway.copy": "复制",
	"gateway.copied": "已复制",
	"gateway.apiKey": "Bearer 密钥",
	"gateway.keyAbsent": "尚未生成",
	"gateway.reveal": "显示密钥",
	"gateway.rotate": "轮换密钥",
	"gateway.rotateConfirm": "确认轮换（旧密钥立即失效）",
	"gateway.snippetsTitle": "客户端配置示例",
	"gateway.snippetsHint": "将 YOUR_GATEWAY_KEY 替换为上方 Bearer 密钥；示例仅供本机 loopback 使用。",
	"gateway.snippet.cursor": "Cursor / Claude Desktop",
	"gateway.copyFailed": "复制失败，请手动复制。",
	"gateway.snippetsModelMissing": "请先连接订阅并选择模型，之后才能生成可执行示例。",
	"gateway.snippetsKeyMissing": "请先生成 Gateway 密钥，之后才能生成可执行示例。",
	"gateway.snippetsKeyHidden": "示例使用 YOUR_GATEWAY_KEY 占位符；显示密钥后再替换它。",
	"compatibility.title": "兼容性诊断",
	"compatibility.intro": "显示 DSH 与可选能力的兼容状态；不包含凭据或密钥。",
	"compatibility.status": "状态",
	"compatibility.dshVersion": "DSH 版本",
	"compatibility.abi": "核心 ABI",
	"compatibility.uiOwner": "界面所有者",
	"compatibility.accessMode": "访问模式",
	"compatibility.capabilities": "能力",
	"compatibility.diagnostics": "诊断信息",
	"compatibility.diagnosticsEmpty": "没有降级原因。",
	"compatibility.error": "暂时无法读取兼容性诊断。",
	"compatibility.unavailable": "不可用",
	"compatibility.status.healthy": "正常",
	"compatibility.status.degraded": "已降级",
	"compatibility.status.incompatible": "不兼容",
	"compatibility.capability.available": "可用",
	"compatibility.capability.missing": "缺失",
	"compatibility.capability.incompatible": "不兼容",
	"recovery.open": "打开用量中心",
	"recovery.title": "用量中心已就绪",
	"recovery.message": "当前 DSH 界面未提供完整设置插槽。可继续使用独立入口，宿主能力恢复后会自动切换到完整界面。",
	"capabilities.intro": "可选能力默认全部关闭，打开后立即生效。这些能力使用供应商的私有端点，请确认符合你的订阅条款。",
	"capabilities.readonly": "当前设置服务为只读，请在插件配置 YAML 中调整 capabilities。",
	"capabilities.conflict": "设置已被其他页面修改，已刷新为最新值，请重试。",
	"capabilities.saved": "已保存",
	"capabilities.codexSearch": "Codex 搜索",
	"capabilities.codexSearchHint": "允许通过 Codex 订阅的私有端点进行搜索。",
	"capabilities.codexImages": "Codex 图像生成",
	"capabilities.codexImagesHint": "使用 gpt-image-2 生成图像。",
	"capabilities.codexImageEdits": "Codex 图像编辑",
	"capabilities.codexImageEditsHint": "仅接受当前会话持有的附件作为编辑输入。",
	"capabilities.codexUsage": "Codex 用量读取",
	"capabilities.codexUsageHint": "读取 Codex 订阅的私有用量端点。",
	"capabilities.codexFast": "Codex Fast（priority）",
	"capabilities.codexFastHint": "对支持 priority 的模型请求 service_tier=priority；不保证上游兑现。",
	"capabilities.codexSpeedTitle": "速度",
	"capabilities.codexSpeedStandard": "标准",
	"capabilities.codexSpeedFast": "Fast",
	"capabilities.codexSpeedWaiting": "等待实时目录出现 priority 模型后再发布 Fast 路由。",
	"capabilities.codexSpeedPickerHint":
		"会话模型选择器在请求 Fast 时使用已有的 codex-oauth-fast 路由（非第二套 Fast 栈）。",
	"capabilities.grokImagineImage": "Grok Imagine 图像",
	"capabilities.grokImagineImageHint": "走官方 api.x.ai，使用独立的 XAI_API_KEY 凭据（非 OAuth）。",
	"capabilities.grokImagineVideo": "Grok Imagine 视频",
	"capabilities.grokImagineVideoHint": "视频产物有总量与保留期硬限，仅经同源回环路由提供。",
	"capabilities.searchResults": "搜索结果条数（1–20）",
	"capabilities.imageCount": "图像生成张数（1–4）",
	"capabilities.videoTtl": "视频产物保留时长（小时）",
	"capabilities.videoTtlHint": "1–168 小时；缩短会立即清理已有产物。",
	"capabilities.imagineCredential": "XAI_API_KEY 凭据",
	"capabilities.imagineConfigured": "已配置（来源：{source}）",
	"capabilities.imagineMissing": "未配置。Grok Imagine 需要在凭据页配置 XAI_API_KEY。",
	"action.close": "关闭",
	"action.retry": "重试",
};

export const en = {
	"oauth.opencodeGo.protocol": "Request protocol",
	"oauth.opencodeGo.protocolHint":
		"This protocol applies to all models in the Go service. Use the protocol published for your model; remove incompatible models in DSH model settings before switching.",
	"capabilities.accountRequired": "Connect the related account before using these capabilities.",
	"gateway.go.title": "OpenCode Go for external tools",
	"gateway.go.hint":
		"Use the exact model name and protocol below (coding-opencode-go/<model-id>; legacy opencode-go/<model-id> is still accepted). Each conversation must send a stable x-opencode-session header. Your existing local key only authenticates the client; the upstream key is resolved from the selected credential reference.",
	"gateway.go.migration":
		"The old global forwarding mode needs migration. Review these client changes before applying. The local key will stay unchanged.",
	"gateway.go.empty": "No Go route selected. Connect Go in Accounts & Models, then review its configured models here.",
	"gateway.go.edit": "Review Go route",
	"gateway.go.apply": "Apply this route",
	"gateway.go.disable": "Remove Go route",
	"gateway.go.cancel": "Close preview",
	"gateway.go.credential": "Upstream credential source",
	"oauth.usageProviderScope": "Provider usage snapshots; not linked to individual signed-in accounts.",
	"settings.accountsTitle": "Accounts & Models",
	"settings.accountsIntro": "Connect services, manage account authorization, and choose visible models.",
	"settings.costBasis":
		"Token costs are estimates based on configured prices. Subscription spending is tracked separately; these figures are not provider invoices.",
	"settings.tab.overview": "Overview",
	"settings.unsavedConfirm": "Discard unsaved changes and leave this view?",
	"oauth.opencodeGo.status.conflict":
		"Session header conflict. Edit the connection to remove the static session header.",
	"oauth.opencodeGo.status.cancelled": "The latest Go request was cancelled.",
	"oauth.opencodeGo.status.pending": "Go request in progress; waiting for the complete result.",
	"oauth.opencodeGo.configurationChanged":
		"Settings changed in another view. Load and review the latest settings before applying your input.",
	"oauth.opencodeGo.readOnly":
		"This credential source or model configuration is read-only. Existing authorization can be reused.",
	"oauth.opencodeGo.applied": "Model settings applied. Select an enabled model in DSH to start a conversation.",
	"oauth.opencodeGo.credentialSaved": "Credential saved or selected for reuse; conversation has not been verified.",
	"oauth.opencodeGo.reload": "Load latest settings and keep input",
	"oauth.opencodeGo.cancel": "Discard edits",
	"oauth.opencodeGo.edit": "Edit connection",
	"sidebar.label": "Usage Center",
	"sidebar.open": "Open usage preview",
	"peek.title": "Usage preview",
	"peek.dashboard": "Open full dashboard",
	"peek.quotaStrip": "Tightest quotas",
	"dashboard.title": "Usage & quotas",
	"dashboard.subtitle": "Local-only history · all costs are estimates",
	"dashboard.loading": "Loading local usage…",
	"dashboard.error": "Usage data is unavailable: {message}",
	"error.browserContext":
		"DSH Web could not validate this request origin. Refresh the page; forwarded X-Forwarded-Host/X-Forwarded-Proto headers alone are insufficient. A reverse proxy also needs a trusted peer, exact HTTPS Origin/Host, owner proof, and Fetch Metadata; mutations additionally require CSRF.",
	"dashboard.empty": "No usage data yet",
	"dashboard.noData":
		"Usage has not been collected yet. Connect a subscription or configure a provider; after a successful sync, this view distinguishes true zero usage from missing data.",
	"dashboard.updated": "Updated {time} ago",
	"dashboard.stale": "Last successful update {time} ago · data is stale",
	"dashboard.staleData": "Showing the last successful result because the source is marked stale.",
	"dashboard.retainedAfterError": "Refresh failed; the last successful result is preserved: {message}",
	"dashboard.coverage": "{value}% priced",
	"dashboard.tab.overview": "Overview",
	"dashboard.tab.activity": "Activity",
	"dashboard.tab.accounts": "Accounts",
	"dashboard.tab.breakdown": "Breakdown",
	"dashboard.tab.local": "Local",
	"metric.tokens": "Tokens",
	"metric.cost": "Estimated cost",
	"metric.requests": "Requests",
	"metric.cacheHit": "Cache hit rate",
	"metric.providers": "Active providers",
	"metric.alerts": "Alerts",
	"range.today": "Today",
	"range.7d": "7 days",
	"range.30d": "30 days",
	"range.month": "This month",
	"group.provider": "By provider",
	"group.model": "By model",
	"group.none": "Total",
	"toolbar.compare": "Compare previous period",
	"toolbar.refresh": "Refresh",
	"toolbar.refreshing": "Refreshing…",
	"toolbar.export": "Export",
	"toolbar.exportCsv": "Export CSV",
	"toolbar.exportJson": "Export JSON",
	"toolbar.exportDaily": "Daily CSV",
	"toolbar.exportBundle": "Bundle JSON",
	"toolbar.clearFilter": "Clear filter",
	"toolbar.range": "Date range",
	"toolbar.metric": "Metric",
	"toolbar.group": "Group",
	"alert.level.info": "Info",
	"alert.level.warning": "Warning",
	"alert.level.critical": "Critical",
	"alert.dailyCost": "Daily estimated cost ({currency})",
	"accounts.emptyGuide":
		"No monitorable accounts yet. Sign in or add credentials under Settings → Subscription accounts.",
	"accounts.configure": "Configure accounts",
	"accounts.manage": "Manage subscription accounts",
	"accounts.roiBadge": "Plan {monthly} · usage {usage} · payback ×{payback}",
	"breakdown.priced": "{value}% priced",
	"pricing.providerPattern": "Provider pattern",
	"pricing.modelPattern": "Model pattern",
	"pricing.inputPerMillion": "Input per million",
	"pricing.outputPerMillion": "Output per million",
	"pricing.cacheReadPerMillion": "Cache read per million",
	"pricing.cacheWritePerMillion": "Cache write per million",
	"pricing.add": "Add price rule",
	"pricing.remove": "Remove",
	"pricing.presetsHint": "Load common provider estimate templates (edit before saving):",
	"pricing.preset.openai": "OpenAI preset",
	"pricing.preset.anthropic": "Anthropic preset",
	"pricing.preset.deepseek": "DeepSeek preset",
	"fees.datePlaceholder": "YYYY-MM-DD",
	"activity.title": "Activity heatmap",
	"activity.streak": "{current}-day streak · longest {longest}",
	"activity.metricTokens": "Colored by tokens (rolling 370 days)",
	"activity.metricCost": "Colored by estimated cost (rolling 370 days)",
	"activity.metricRequests": "Colored by requests (rolling 370 days)",
	"activity.less": "Less",
	"activity.more": "More",
	"activity.weekday.sun": "Sun",
	"activity.weekday.mon": "Mon",
	"activity.weekday.tue": "Tue",
	"activity.weekday.wed": "Wed",
	"activity.weekday.thu": "Thu",
	"activity.weekday.fri": "Fri",
	"activity.weekday.sat": "Sat",
	"activity.dayDetail": "Day detail",
	"activity.dayRequests": "{value} requests",
	"activity.clearDay": "Clear selection",
	"module.kpi": "Overview KPIs",
	"module.heatmap": "Activity heatmap",
	"module.trend": "Trend",
	"module.accounts": "Accounts & quotas",
	"module.alerts": "Alerts",
	"module.breakdown": "Breakdown",
	"module.local": "Local auth & usage",
	"local.auth.title": "Local authentication",
	"local.auth.hint":
		"Read-only probes of allowlisted official CLI credentials and this plugin's OAuth sessions. Token material is never read into the page.",
	"local.auth.disabled":
		"Local authentication monitoring is off. Set localMonitor.enabled: true in the plugin configuration and restart to enable it.",
	"local.auth.signedIn": "Signed in",
	"local.auth.signedOut": "Signed out",
	"local.auth.expired": "Expired",
	"local.auth.noExpiry": "No expiry",
	"local.auth.expiresAt": "Expires in {time}",
	"local.auth.hasRefresh": "refresh token present",
	"local.auth.pluginSession": "DSH session · {route}",
	"local.auth.pluginSessionHint": "OAuth sign-in stored by this plugin",
	"local.usage.title": "Cross-tool local usage",
	"local.usage.hint":
		"Parses other CLIs' local session logs and extracts only timestamps, models, and token counts. Conversation content is never read.",
	"local.usage.disabled":
		"Cross-tool usage scanning is off (the default). Set localUsage.enabled: true in the plugin configuration and restart to enable it.",
	"local.usage.empty": "No local usage scanned yet",
	"local.usage.scan": "Scan now",
	"local.usage.scanning": "Scanning…",
	"local.usage.neverScanned": "Never scanned",
	"local.openCapabilities": "Open capabilities settings",
	"local.usage.tool": "Tool",
	"local.usage.models": "Models",
	"statusProbes.title": "Vendor status pages",
	"statusProbes.hint":
		"Read-only probes of allowlisted public Statuspage endpoints (no credentials; outbound/SSRF policy enforced). Default off; failures never affect the Usage primary path.",
	"statusProbes.disabled":
		"Vendor status-page probes are off (the default). Set statusProbes.enabled: true in the plugin configuration and restart to enable them.",
	"statusProbes.empty": "No probe results yet",
	"statusProbes.indicator.none": "Operational",
	"statusProbes.indicator.minor": "Minor",
	"statusProbes.indicator.major": "Major",
	"statusProbes.indicator.critical": "Critical",
	"statusProbes.indicator.unknown": "Unknown",
	"statusProbes.failed": "Probe failed ({code})",
	"trend.title": "Trend",
	"breakdown.title": "Breakdown",
	"breakdown.dimension": "Dimension",
	"breakdown.tokens": "Tokens",
	"breakdown.share": "Share",
	"breakdown.requests": "Requests",
	"breakdown.cache": "Cache",
	"breakdown.cost": "Cost",
	"comparison.none": "No comparison baseline",
	"comparison.change": "{value} vs previous period",
	"accounts.title": "Accounts & quotas",
	"accounts.empty": "No monitorable accounts discovered",
	"accounts.remaining": "remaining",
	"accounts.reset": "Resets in {time}",
	"accounts.lastGood": "Last good {time}",
	"status.stale": "Data is stale",
	"status.updated": "Updated just now",
	"status.ok": "OK",
	"status.pending": "Pending",
	"status.not-configured": "Not configured",
	"status.unsupported": "Quota lookup unavailable",
	"status.auth-error": "Auth error",
	"status.rate-limited": "Rate limited",
	"status.unavailable": "Unavailable",
	"status.error": "Error",
	"breakdown.cacheRead": "Cache read",
	"breakdown.cacheWrite": "Cache write",
	"breakdown.input": "Input",
	"breakdown.output": "Output",
	"settings.autoExport": "Automatic export directory",
	"settings.autoExportHint":
		"Writes only to a local absolute path; never writes credentials or sessions. Leave empty to disable.",
	"settings.autoExportEnabled": "Enable scheduled export to a local directory",
	"settings.autoExportPath": "Export directory (absolute path)",
	"settings.autoExportLayout": "Export layout",
	"settings.nav": "Usage",
	"settings.title": "Usage",
	"settings.patchFailed":
		"Settings were not saved. Your current changes are still kept; reload the latest settings when ready.",
	"settings.reload": "Reload latest settings",
	"settings.conflictNoOverlap":
		"Settings changed elsewhere. Your edits do not overlap, so you can reapply them on top of the latest settings.",
	"settings.conflictFields":
		"These settings changed in both places: {fields}. Keep your edits or use the latest settings.",
	"settings.conflictSeparator": ", ",
	"settings.keepLocal": "Keep my edits and reapply",
	"settings.useLatest": "Use latest settings",
	"settings.section.display": "display",
	"settings.section.providers": "provider display",
	"settings.section.privacy": "privacy",
	"settings.section.alerts": "alerts",
	"settings.intro":
		"Configure the default view, subscription OAuth sign-in, the local gateway, provider actions, fees, and privacy.",
	"onboarding.title": "Finish setup in three steps",
	"onboarding.intro":
		"Connect a subscription, confirm pricing, then enable the local Gateway only if you need it. Every step remains editable.",
	"onboarding.progress": "{completed} of {total} complete",
	"onboarding.subscription.title": "Connect a subscription",
	"onboarding.subscription.hint": "Sign in to at least one Coding OAuth account and choose the models to expose.",
	"onboarding.pricing.title": "Sync or configure pricing",
	"onboarding.pricing.hint": "Load a preset or add rules so unpriced usage is not mistaken for zero cost.",
	"onboarding.gateway.title": "Configure Gateway",
	"onboarding.gateway.hint":
		"If you need a local API endpoint, enable the loopback Gateway and generate a separate key.",
	"onboarding.gateway.skip": "I don't need Gateway",
	"onboarding.loading": "Checking the current setup…",
	"onboarding.start": "Start",
	"onboarding.review": "Review",
	"settings.preview": "Open full dashboard",
	"settings.openPeek": "Open usage preview",
	"settings.tab.display": "Display",
	"settings.tab.accounts": "Subscriptions",
	"settings.tab.gateway": "Gateway",
	"settings.tab.capabilities": "Capabilities",
	"settings.tab.providers": "Providers",
	"settings.tab.fees": "Fees",
	"settings.display": "Display & defaults",
	"settings.preset": "Dashboard preset",
	"settings.sidebarMetric": "Sidebar / HUD metric",
	"settings.entryMode": "Entry surface",
	"settings.entryMode.sidebar": "Sidebar button",
	"settings.entryMode.floating": "Floating HUD",
	"settings.entryModeHint":
		"Use the floating HUD when other plugins crowd the sidebar foot; Settings always opens Usage Center",
	"hud.more": "+{count}",
	"hud.openPeek": "Open usage preview",
	"settings.defaultRange": "Default range",
	"settings.compare": "Compare previous period by default",
	"settings.density": "Interface density",
	"settings.motion": "Motion",
	"preset.minimal": "Minimal",
	"preset.quota": "Quota",
	"preset.cost": "Cost",
	"preset.analyst": "Analyst",
	"density.compact": "Compact",
	"density.comfortable": "Comfortable",
	"motion.system": "Follow system",
	"motion.always": "Always reduce",
	"motion.never": "Always animate",
	"settings.timeZone": "Time zone",
	"settings.baseCurrency": "Base currency",
	"settings.streakMinTokens": "Streak minimum tokens",
	"settings.modules": "Dashboard modules",
	"settings.modulesHint":
		"Toggle visibility and reorder. After customization, presets no longer overwrite module layout; reset to apply the current preset.",
	"settings.resetModules": "Reset to current preset",
	"settings.moveUp": "Move up",
	"settings.moveDown": "Move down",
	"settings.alias": "Display alias",
	"settings.color": "Chart color",
	"settings.privacy": "Privacy & export",
	"settings.alerts": "Local soft alerts",
	"settings.alertsEnabled": "Enable quota, cost, and account health alerts",
	"settings.quotaThreshold": "Quota remaining threshold (%)",
	"settings.dailyCostThreshold": "Daily estimated cost threshold (blank to disable)",
	"settings.showSessions": "Allow session identifiers in breakdowns",
	"settings.redactExports": "Redact sensitive identifiers in exports",
	"settings.save": "Save settings",
	"settings.saving": "Saving…",
	"settings.saved": "Settings saved",
	"settings.fees": "Subscription & top-up fees",
	"settings.feesIntro":
		"Local ledger for payback display only; never included in default exports. Payback requires matching base currency and priced monthly cost coverage.",
	"settings.feesSaved": "Fee ledger saved",
	"settings.credentials": "Providers and credentials",
	"settings.credentialsIntro":
		"Connection state is assembled on the local server. Credential values, device codes, and raw provider payloads are never returned to the browser.",
	"settings.providersTitle": "Provider status & actions",
	"settings.providersIntro":
		"Review connection state and maintain auth directly on each card: save/clear API keys, start device authorization, refresh per provider, or jump to Subscriptions for OAuth sign-in.",
	"settings.apiCredentials": "API keys & device authorization (advanced)",
	"settings.apiCredentialsIntro":
		"For routine maintenance use the provider cards above; this editor reads/writes any allowed credential by its reference name. Credential values never return to the browser.",
	"settings.accountVisibility": "Account usage visibility",
	"settings.accountVisibilityHint":
		"Toggles control whether each account appears in Peek and the Accounts dashboard; set an alias and chart color.",
	"settings.accountVisible": "Show {name} on the dashboard",
	"settings.accountShown": "Shown in usage views",
	"settings.accountHidden": "Hidden from usage views",
	"fees.kind": "Kind",
	"fees.subscription": "Subscription",
	"fees.topup": "Top-up",
	"fees.providerId": "Provider ID",
	"fees.planName": "Plan name",
	"fees.amount": "Amount",
	"fees.currency": "Currency",
	"fees.interval": "Interval",
	"fees.intervalMonth": "Month",
	"fees.intervalYear": "Year",
	"fees.nextRenewal": "Renews {date}",
	"fees.nextRenewalDate": "Next renewal",
	"fees.monthlyEquivalent": "≈ {value} / month",
	"fees.payback": "Month usage payback ×{value}",
	"fees.paybackUnavailable": "Payback unavailable (currency mismatch or uncovered monthly cost)",
	"fees.notes": "Notes",
	"fees.add": "Add fee entry",
	"fees.remove": "Remove",
	"fees.errorRequired": "This field is required",
	"fees.errorAmount": "Enter an amount that is zero or greater",
	"fees.errorDate": "Enter a valid date (YYYY-MM-DD)",
	"fees.loading": "Loading fee records…",
	"fees.loadFailed": "Could not load fee records: {message}",
	"providers.connected": "Connected",
	"providers.needsAttention": "Needs attention",
	"providers.unconfigured": "Unconfigured",
	"providers.unsupported": "Unsupported",
	"providers.auth": "Auth",
	"providers.models": "Models",
	"providers.quota": "Quota",
	"providers.token": "Token",
	"providers.empty": "No manageable providers yet.",
	"providers.showInDashboard": "Show on dashboard",
	"providers.showInDashboardNamed": "Show {name} on the dashboard",
	"providers.openAccounts": "Open Subscriptions to sign in / pull",
	"providers.credentialsTitle": "Credentials",
	"providers.credentialOAuthManaged": "Maintained by OAuth sign-in / local CLI pull under Subscriptions.",
	"providers.credentialReadOnly": "The server credential store is read-only; maintain this reference in configuration.",
	"providers.refreshNow": "Refresh now",
	"providers.refreshing": "Refreshing…",
	"providers.deviceDone": "Authorized and saved",
	"providers.group.needsAttention": "Needs attention",
	"providers.group.connected": "Connected",
	"providers.group.unconfigured": "Unconfigured",
	"providers.group.unsupported": "Monitoring unsupported",
	"providers.next.unsupported":
		"This provider does not support quota monitoring; keep the route, but no usable quota card will appear.",
	"providers.next.connected": "Connected. Use the toggle above to control dashboard visibility.",
	"providers.next.oauth":
		"Subscription/OAuth provider: sign in under Subscriptions, or pull from the local CLI on the same card.",
	"providers.next.apiKey": "Needs an API key: save the matching key in this card's Credentials section.",
	"providers.next.refresh": "Token expiring or expired: sign in again or refresh the credential.",
	"providers.next.review": "Review auth and quota state, then sign in, save a key, or hide the provider.",
	"connection.connected": "Connected",
	"connection.signing-in": "Signing in",
	"connection.configured-failing": "Configured, failing",
	"connection.configured-unknown": "Configured, unverified",
	"connection.unconfigured": "Unconfigured",
	"connection.expired": "Expired",
	"connection.expiring": "Expiring",
	"connection.unavailable": "Unavailable",
	"connection.unsupported": "Unsupported",
	"authSource.api-key": "API key",
	"authSource.oauth": "OAuth subscription",
	"authSource.local-cli": "Local CLI",
	"authSource.mixed": "Mixed",
	"authSource.none": "None",
	"tokenLifecycle.valid": "Valid",
	"tokenLifecycle.expiring": "Expiring",
	"tokenLifecycle.refresh-required": "Refresh required",
	"tokenLifecycle.unknown": "Unknown",
	"tokenLifecycle.none": "No token",
	"modelState.enabled": "Enabled",
	"modelState.available-not-enabled": "Available, not enabled",
	"modelState.none": "None",
	"modelState.unknown": "Unknown",
	"quotaState.available": "Available",
	"quotaState.stale": "Stale",
	"quotaState.disabled": "Disabled",
	"quotaState.unavailable": "Unavailable",
	"quotaState.not-supported": "Not supported",
	"quotaState.unlinked": "Not linked",
	"quotaDiag.missing-credential": "Quota credential missing",
	"quotaDiag.missing-chatgpt-account-id": "Token is missing ChatGPT account id; sign in to Codex again",
	"quotaDiag.invalid-response": "Upstream response had no recognizable quota windows",
	"quotaDiag.auth-error": "Credential invalid or expired",
	"quotaDiag.unauthorized": "Unauthorized",
	"quotaDiag.rate-limited": "Upstream rate limited",
	"quotaDiag.unavailable": "Upstream unavailable",
	"quotaDiag.unsupported": "Upstream does not support this probe",
	"quotaDiag.managed-externally": "Managed by an external plugin",
	"quotaDiag.warning:remaining-percent": "Quota remaining is low",
	"quotaDiag.critical:remaining-percent": "Quota remaining is critical",
	"quotaDiag.warning:balance": "Balance is low",
	"quotaDiag.critical:balance": "Balance is critical",
	"quotaDiag.upstream-error": "Upstream probe failed",
	"credential.ref": "Credential reference",
	"credential.value": "New credential value",
	"credential.configured": "Configured",
	"credential.missing": "Not configured",
	"credential.save": "Save securely",
	"credential.remove": "Remove",
	"credential.import": "Import local CLI credential",
	"credential.provider": "Local CLI",
	"credential.oauth": "Device authorization",
	"credential.oauthHint": "Requires a trusted GitHub public OAuth client ID in runtime configuration.",
	"credential.error": "Credential operation failed",
	"credential.start": "Start authorization",
	"credential.poll": "I completed authorization",
	"credential.open": "Open authorization page",
	"credential.code": "Enter code {code}",
	"pricing.title": "Custom pricing",
	"pricing.intro": "Set estimated per-million-token prices by provider/model. Uncovered usage is never guessed.",
	"pricing.import": "Import JSON",
	"pricing.invalid": "Invalid pricing JSON",
	"pricing.previewTitle": "Preview changes before applying {source}",
	"pricing.previewDiff": "{added} added, {changed} changed, {removed} removed.",
	"pricing.previewDirty": "You have unsaved edits. Continuing replaces those drafts with the previewed rules.",
	"pricing.previewApply": "Confirm replacement",
	"pricing.undo": "Undo last replacement",
	"oauth.accountsIntro":
		"Sign in with your subscription accounts via OAuth. Signed-in models appear in the model picker marked (OAuth). Credentials stay on this machine and never enter chats, logs, or pages.",
	"oauth.status.signedOut": "Signed out",
	"oauth.status.signingIn": "Authorizing",
	"oauth.status.signedIn": "Signed in",
	"oauth.status.error": "Error",
	"oauth.recovery.reauthorize": "The credential expired or authorization was denied. Authorize again.",
	"oauth.recovery.storage":
		"Local sign-in storage could not be updated. Resolve the storage or writer lock, then reload.",
	"oauth.recovery.network": "The local service could not be reached or the request timed out. Reload the status.",
	"oauth.recovery.retry": "The operation could not complete. Reload the status and try again.",
	"oauth.recovery.reauthorizeAction": "Authorize again",
	"oauth.recovery.manageAccount": "Refresh and manage accounts",
	"oauth.reauthorizeHint":
		"Update only this account without changing the default. If the service does not disclose identity, verify this account on its authorization page before continuing.",
	"oauth.recovery.retryAction": "Reload status",
	"oauth.grokNote":
		"SuperGrok / X Premium subscription via the Grok Build channel. Use device-code sign-in on remote or headless hosts.",
	"oauth.note.codex": "ChatGPT Plus/Pro subscription. Device-code sign-in is recommended on remote or headless hosts.",
	"oauth.note.kimi": "Kimi Code subscription. Device-code sign-in only.",
	"oauth.note.claude":
		"Claude Pro/Max subscription. From a remote browser, paste the full localhost redirect URL back here.",
	"oauth.note.copilot":
		"GitHub Copilot subscription. Appears only after oauthDevice.copilotClientId is configured; device-code sign-in.",
	"oauth.loginBrowser": "Browser authorization",
	"oauth.loginDevice": "Device-code sign-in",
	"oauth.cancelLogin": "Cancel",
	"oauth.openPage": "Open authorization page",
	"oauth.pasteCode": "Paste the authorization code or full redirect URL",
	"oauth.submitCode": "Submit code",
	"oauth.waitingDevice": "Enter the code above on the authorization page; this panel updates automatically.",
	"oauth.logout": "Sign out",
	"oauth.accountsListHint": "Saved subscription accounts on this machine (no tokens):",
	"oauth.accountActive": "Default",
	"oauth.accountSetDefault": "Set default",
	"oauth.accountDefaultHint": "Setting the default affects only requests sent later.",
	"oauth.accountRemove": "Remove",
	"oauth.accountRemoveConfirm":
		"Remove {account} from DSH local storage? This does not change official CLI authorization files.",
	"oauth.accountRemoveConfirmAction": "Confirm remove",
	"oauth.logoutConfirmHint":
		"Sign out this provider's locally stored DSH login? This does not change official CLI authorization files.",
	"oauth.logoutConfirmAction": "Confirm sign out",
	"oauth.accountAdd": "Add account",
	"oauth.accountsAtCap": "Account limit reached ({max}). Remove one before adding another.",
	"oauth.tokenExpired": "Access token expired; it refreshes automatically before the next request",
	"oauth.tokenExpiresIn": "Access token expires in about {value} (auto-refresh)",
	"oauth.modelsHint":
		"Model visibility applies to all accounts of this service. Clearing the selection hides every model while retaining authorization.",
	"oauth.modelsDefault": "Use default model set",
	"oauth.modelsHideAll": "Deselect all",
	"oauth.modelsHidden": "Account connected; no models are shown.",
	"oauth.modelsEmpty": "No models in the catalog yet",
	"oauth.modelsSave": "Save model selection",
	"oauth.modelsSaved": "Model selection saved",
	"oauth.antigravity.title": "Google Antigravity",
	"oauth.antigravity.installed": "Provided by the dsh-agy plugin; manage its account via the dsh-agy CLI.",
	"oauth.antigravity.notInstalled": "Not installed. Optionally install the pinned dsh-agy plugin to enable it.",
	"oauth.importTitle": "Pull credentials from local CLIs",
	"oauth.importHint":
		"Read-only discovery of allowlisted official CLI OAuth files. Pulling is an explicit one-way copy after preview and confirmation; the official CLI files are never modified.",
	"oauth.importInlineHint":
		"You can also pull from the official local CLI (read-only preview, then confirm; official CLI files are never modified).",
	"oauth.importPull": "Preview & pull",
	"oauth.importClaudeCode": "Import Claude Code",
	"oauth.importCommit": "Confirm pull",
	"oauth.usageCachedHint": "Provider aggregate usage windows (cached, read-only; not an exact per-account attribution)",
	"oauth.importCancel": "Cancel",
	"oauth.importConfirmOverwrite": "Overwrite the currently saved sign-in with the CLI credential",
	"oauth.importUnavailable.missing": "Not found",
	"oauth.importUnavailable.unsafe": "Unsafe file permissions",
	"oauth.importUnavailable.invalid": "Unrecognized content",
	"oauth.importUnavailable.too_large": "File too large",
	"oauth.importConflict.none": "No saved sign-in yet",
	"oauth.importConflict.same_credential": "Identical to the saved sign-in",
	"oauth.importConflict.same_account": "Same account as the saved sign-in",
	"oauth.importConflict.different_account": "Different account than the saved sign-in",
	"oauth.importConflict.unknown_account": "Cannot confirm whether it matches the saved sign-in",
	"oauth.importConflict.unreadable_destination": "The saved sign-in cannot be parsed",
	"oauth.importConflict.unsafe_destination": "The saved credential file has unsafe permissions",
	"oauth.importAction.import": "Will be pulled as a new sign-in",
	"oauth.importAction.reuse": "No change needed",
	"oauth.importAction.overwrite": "Will overwrite the saved sign-in",
	"oauth.importAction.blocked": "Blocked",
	"oauth.importDone.imported": "Pulled",
	"oauth.importDone.unchanged": "No change",
	"oauth.importDone.overwritten": "Overwritten",
	"oauth.opencodeGo.title": "OpenCode Go",
	"oauth.opencodeGo.description":
		"Connect OpenCode Go under the isolated provider coding-opencode-go, then select its model in DSH. No external gateway is required.",
	"oauth.opencodeGo.providerIdHint": "Plugin provider id: {providerId} (separate from DSH-native opencode-go)",
	"oauth.opencodeGo.legacyMigration":
		"A previous plugin configuration was found under {legacyId}. Migrate it to {providerId} so chat no longer shares the DSH-native provider slot.",
	"oauth.opencodeGo.migrate": "Migrate to isolated provider",
	"oauth.opencodeGo.compatibilityNote":
		"This is header compatibility, not OAuth. It does not represent quota or a successful model call.",
	"oauth.opencodeGo.credential": "Credential source",
	"oauth.opencodeGo.configured": "configured",
	"oauth.opencodeGo.chooseCredential": "Different Go credentials were found. Choose the account to use.",
	"oauth.opencodeGo.apiKey": "API key",
	"oauth.opencodeGo.reuseHint": "Leave blank to reuse the saved credential",
	"oauth.opencodeGo.reuse": "Reuse credential",
	"oauth.opencodeGo.saveKey": "Save key",
	"oauth.opencodeGo.fetchModels": "Fetch models",
	"oauth.opencodeGo.model": "Models",
	"oauth.opencodeGo.modelsHint":
		"Fetch the full directory, then enable models that match the selected protocol. Thinking levels come from known Go capabilities when the directory only returns ids.",
	"oauth.opencodeGo.modelsEmpty": "No models loaded yet. Fetch the directory to list checkboxes here.",
	"oauth.opencodeGo.selectMatching": "Enable all matching protocol",
	"oauth.opencodeGo.clearModels": "Clear selection",
	"oauth.opencodeGo.directoryLoaded":
		"Model directory loaded. Enable models below, then apply to make them selectable in DSH.",
	"oauth.opencodeGo.conflictPreview": "The following settings will change: {conflicts}. Other settings are preserved.",
	"oauth.opencodeGo.confirmConflict": "I reviewed and approve these settings changes",
	"oauth.opencodeGo.apply": "Apply to DSH",
	"oauth.opencodeGo.startConversation": "Start conversation",
	"oauth.opencodeGo.status.no-call": "No OpenCode Go conversation request has run yet.",
	"oauth.opencodeGo.status.success": "The latest Go request completed successfully.",
	"oauth.opencodeGo.status.failure":
		"The latest OpenCode Go conversation request failed. Check DSH model settings and retry.",
	"oauth.opencodeGo.status.missing-session":
		"DSH did not provide a session identity. Return to the conversation and retry.",
	"oauth.opencodeGo.regionOptIn": "This model is China-hosted and needs an explicit OpenCode workspace opt-in.",
	"gateway.intro":
		"An optional loopback OpenAI/Anthropic-compatible gateway that reuses your signed-in subscription sessions. It serves only your local tools and is not a public relay.",
	"gateway.enabled": "Enable the local API gateway",
	"gateway.opencodeGoEnabled": "Proxy chat to OpenCode Go",
	"gateway.opencodeGoHint":
		"The legacy global proxy remains visible for migration only and no longer reuses the local access key upstream. Connect Go under Accounts & Models first.",
	"gateway.running": "Listening",
	"gateway.stopped": "Not running",
	"gateway.bind": "Bind address",
	"gateway.bindHint":
		"The bind address can only be changed in the plugin YAML configuration; a non-loopback bind requires an API key.",
	"gateway.port": "Listen port",
	"gateway.portApply": "Apply",
	"gateway.portRandom": "Random",
	"gateway.baseUrlOpenai": "OpenAI base URL",
	"gateway.baseUrlAnthropic": "Anthropic base URL",
	"gateway.copy": "Copy",
	"gateway.copied": "Copied",
	"gateway.apiKey": "Bearer key",
	"gateway.keyAbsent": "Not generated yet",
	"gateway.reveal": "Reveal key",
	"gateway.rotate": "Rotate key",
	"gateway.rotateConfirm": "Confirm rotation (the old key stops working immediately)",
	"gateway.snippetsTitle": "Client configuration examples",
	"gateway.snippetsHint":
		"Replace YOUR_GATEWAY_KEY with the Bearer key above. Examples are for local loopback use only.",
	"gateway.snippet.cursor": "Cursor / Claude Desktop",
	"gateway.copyFailed": "Copy failed. Copy it manually instead.",
	"gateway.snippetsModelMissing": "Connect a subscription and select a model before generating a runnable example.",
	"gateway.snippetsKeyMissing": "Generate a Gateway key before generating a runnable example.",
	"gateway.snippetsKeyHidden": "Examples use the YOUR_GATEWAY_KEY placeholder; reveal the key before replacing it.",
	"compatibility.title": "Compatibility diagnostics",
	"compatibility.intro": "Shows DSH and optional capability compatibility without exposing credentials or keys.",
	"compatibility.status": "Status",
	"compatibility.dshVersion": "DSH version",
	"compatibility.abi": "Core ABI",
	"compatibility.uiOwner": "UI owner",
	"compatibility.accessMode": "Access mode",
	"compatibility.capabilities": "Capabilities",
	"compatibility.diagnostics": "Diagnostics",
	"compatibility.diagnosticsEmpty": "No degradation reasons reported.",
	"compatibility.error": "Compatibility diagnostics could not be loaded.",
	"compatibility.unavailable": "Unavailable",
	"compatibility.status.healthy": "Healthy",
	"compatibility.status.degraded": "Degraded",
	"compatibility.status.incompatible": "Incompatible",
	"compatibility.capability.available": "Available",
	"compatibility.capability.missing": "Missing",
	"compatibility.capability.incompatible": "Incompatible",
	"recovery.open": "Open Usage Center",
	"recovery.title": "Usage Center is ready",
	"recovery.message":
		"This DSH UI does not currently provide the full settings slots. Use this standalone entry; it will switch to the full interface when host support becomes available.",
	"capabilities.intro":
		"Optional capabilities are all off by default and apply immediately when enabled. They use private vendor endpoints; make sure this complies with your subscription terms.",
	"capabilities.readonly":
		"The settings service is read-only in this deployment; adjust capabilities in the plugin YAML configuration.",
	"capabilities.conflict": "Settings changed elsewhere; refreshed to the latest values. Please retry.",
	"capabilities.saved": "Saved",
	"capabilities.codexSearch": "Codex search",
	"capabilities.codexSearchHint": "Allow search through the Codex subscription private endpoint.",
	"capabilities.codexImages": "Codex image generation",
	"capabilities.codexImagesHint": "Generate images with gpt-image-2.",
	"capabilities.codexImageEdits": "Codex image edits",
	"capabilities.codexImageEditsHint": "Only accepts attachments owned by the current session as edit inputs.",
	"capabilities.codexUsage": "Codex usage reading",
	"capabilities.codexUsageHint": "Read the Codex subscription private usage endpoint.",
	"capabilities.codexFast": "Codex Fast (priority)",
	"capabilities.codexFastHint":
		"Requests service_tier=priority on priority-eligible models; the upstream is not guaranteed to honor it.",
	"capabilities.codexSpeedTitle": "Speed",
	"capabilities.codexSpeedStandard": "Standard",
	"capabilities.codexSpeedFast": "Fast",
	"capabilities.codexSpeedWaiting": "Waiting for a live catalog with priority models before publishing the Fast route.",
	"capabilities.codexSpeedPickerHint":
		"The session model picker uses the existing codex-oauth-fast route when Fast is requested (not a second Fast stack).",
	"capabilities.grokImagineImage": "Grok Imagine images",
	"capabilities.grokImagineImageHint": "Uses the official api.x.ai with a separate XAI_API_KEY credential (not OAuth).",
	"capabilities.grokImagineVideo": "Grok Imagine videos",
	"capabilities.grokImagineVideoHint":
		"Video artifacts have hard size and retention limits and are served only over same-origin loopback routes.",
	"capabilities.searchResults": "Search results (1–20)",
	"capabilities.imageCount": "Images per generation (1–4)",
	"capabilities.videoTtl": "Video artifact retention (hours)",
	"capabilities.videoTtlHint": "1–168 hours; lowering it cleans up existing artifacts immediately.",
	"capabilities.imagineCredential": "XAI_API_KEY credential",
	"capabilities.imagineConfigured": "Configured (source: {source})",
	"capabilities.imagineMissing": "Not configured. Grok Imagine needs XAI_API_KEY on the Credentials tab.",
	"action.close": "Close",
	"action.retry": "Retry",
};

import type { TranslateNS } from "@deepseek-ai/dsh-client-ui-slots";

export type UsageLocaleKey = keyof typeof en;
export type Translate = (key: UsageLocaleKey, params?: Readonly<Record<string, string | number>>) => string;

export function translator(raw: TranslateNS<"usage-stats"> | undefined): Translate {
	return (key, params) => {
		let value = raw?.(key) ?? key;
		if (params !== undefined) {
			for (const [name, replacement] of Object.entries(params)) {
				value = value.replaceAll(`{${name}}`, String(replacement));
			}
		}
		return value;
	};
}
